import endpoints from "../utils/endpoints";
import { message } from "antd";
import { Api } from "./api";
import { notificationError, notificationSucces } from "./notification";
import { IDecksList } from "../pages/DecksManagement/types";

export async function getGamesList(){
    let res: {value: number, name: string}[] = [];

    await Api.get(endpoints.getGamesList).then((response) => {
      res = response.data
    }).catch((err: string) => {
      notificationError('Could not get games list')
    })

    return res || []
}


export async function getDecksList(params: any) {
  let res: IDecksList = {
    headers: [''],
    rows: [],
    topLocation: [''],
    topGame: []
  }
  await Api.get(endpoints.getDecksList, {params}).then((response) => {
    res = response.data
  }).catch((err: string) => {
    notificationError('Could not get list')
  })
  
  return res
}

export async function updateDecksList(params: any): Promise<boolean> {
  let validResponse = false
  await Api.post(endpoints.updateDecksList, params).then((response) => {
    if(response.status === 200) {
        if(response.data.error) {
            notificationError(`${response.data.message}`)
        } else {
          validResponse = true
          notificationSucces('Decks successfully updated')
        }
    }
  }).catch((err: string) => {
    notificationError('Could not update decks')
  })
  return validResponse
}

interface GetDeckCopyParams {
  game: string;
  [id: string]: string;
}

interface ContentGames {
  form: string;
  wager: string;
  locationId: number;
  gameId: number;
  enabled: boolean;
}

interface ItemContentLocationDTO {
  charityName: string;
  countOldVersion: number;
  countVersion: number;
  locationId: number;
  locationName: string;
  disableDeckManagement: boolean;
}

interface GetDeckCopyResponse {
  contentGames: ContentGames[];
  itemContentLocationDTO: ItemContentLocationDTO;
}

export async function getDeckToCopy(params: GetDeckCopyParams): Promise<GetDeckCopyResponse[]> {
  let response: GetDeckCopyResponse[] = []
  await Api.get(endpoints.getGamesToCopy, {params}).then((res) => {
    if(res.status === 200 && res.data) {
      if(res.data.error) {
        notificationError(`${res.data.error}`)
      }
      response = res.data
    } else {
      notificationError('Could not get games to copy')
    }
  }).catch((err: string) => {
    notificationError('Could not get games list')
  })

  return response
}